module.exports = __webpack_public_path__ + "static/media/unlike-after.a2475d45.png";